import { CoordinatorService } from './coordinator.service';
import { NotepadItem } from './notepad-item';

export class ScriptNotepadItem {
    #coords: CoordinatorService;
    #item: NotepadItem;

    constructor(coords: CoordinatorService, item: NotepadItem) {
        this.#coords = coords;
        this.#item = item;
    }

    get notepad() {
        return this.#item.notepad.scriptClass;
    }

    display() {
        this.#coords.isNotepad = true;
    }

    get size() {
        return this.#item.body.length;
    }

    log(prefix = 'Notepad') {
        console.log(`${prefix}: ${this.notepad.title}:${this.#item.body.substring(0, 20)} (${this.size} chars)`);
    }
}
